<template>
  <div class="top-bar">
    <b-navbar
      toggleable="lg"
      class="nav-item-content d-flex justify-content-between align-items-center"
    >
      <h4 click="handleNavLogoClick" style="cursor: pointer;">
        HeartBeatFam
        <small style="color:#605f59">beta</small>
      </h4>
      <!--        <div class="nav-item-content d-flex justify-content-between align-items-center">-->
      <div class="qoute d-flex justify-content-start align-items-center">
        <span class="qoute-coma">
          <svg
            width="18"
            height="13"
            viewBox="0 0 18 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.3125 6.5H13.5V4.78571C13.5 3.84018 14.509 3.07143 15.75 3.07143H16.0312C16.4988 3.07143 16.875 2.78482 16.875 2.42857V1.14286C16.875 0.786607 16.4988 0.5 16.0312 0.5H15.75C12.6422 0.5 10.125 2.41786 10.125 4.78571V11.2143C10.125 11.9241 10.8809 12.5 11.8125 12.5H16.3125C17.2441 12.5 18 11.9241 18 11.2143V7.78571C18 7.07589 17.2441 6.5 16.3125 6.5ZM6.1875 6.5H3.375V4.78571C3.375 3.84018 4.38398 3.07143 5.625 3.07143H5.90625C6.37383 3.07143 6.75 2.78482 6.75 2.42857V1.14286C6.75 0.786607 6.37383 0.5 5.90625 0.5H5.625C2.51719 0.5 0 2.41786 0 4.78571V11.2143C0 11.9241 0.755859 12.5 1.6875 12.5H6.1875C7.11914 12.5 7.875 11.9241 7.875 11.2143V7.78571C7.875 7.07589 7.11914 6.5 6.1875 6.5Z"
              fill="var(--theme-color)"
            />
          </svg>
        </span>
        <h4 v-if="quote">
          "{{ quote.text }}" - <strong> {{ quote.author }}</strong>
        </h4>
      </div>
      <div class="actions d-flex justify-content-around align-items-center">
        <Iona v-if="config.isBeta && profile" :profile="profile" />
        <communicate-chat v-if="config.isBeta && profile" :profile="profile" />
        <to-done-tasks v-if="!config.isBeta" />
        <Notifications v-if="!config.isBeta" />
        <div class="profile">
          <div @click="profilePanel = !profilePanel">
            <b-avatar
              v-if="imgURLPath"
              class="avatar"
              :src="imgURLPath"
              :alt="`${user.firstname} photo`"
            />
            <b-avatar
              v-else
              class="avatar"
              :text="
                getInitials(
                  firstname ? firstname : user.displayName,
                  lastname ? lastname : ''
                )
              "
            />
            <span class="username">
              {{ firstname ? firstname : user.displayName }}
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.52876 5.52861C3.78911 5.26826 4.21122 5.26826 4.47157 5.52861L8.00016 9.0572L11.5288 5.52861C11.7891 5.26826 12.2112 5.26826 12.4716 5.52861C12.7319 5.78896 12.7319 6.21107 12.4716 6.47141L8.47157 10.4714C8.21122 10.7318 7.78911 10.7318 7.52876 10.4714L3.52876 6.47141C3.26841 6.21107 3.26841 5.78896 3.52876 5.52861Z"
                  fill="var(--theme-color)"
                />
              </svg>
            </span>
          </div>
          <div
            class="overlay"
            v-if="profilePanel"
            @click="profilePanel = false"
          ></div>
          <transition name="fade">
            <div v-if="profilePanel" class="profile-panel">
              <ul>
                <li @click="handleMyShelfClick">
                  <span>MyApps Home</span>
                </li>
                <li @click="handleMyProfileClick">
                  <span>My Profile</span>
                </li>
                <li
                  v-if="myHeartBeatName"
                  @click="handleMyHeartBeatNamePageClick"
                >
                  <span>My HeartBeatCentral</span>
                </li>
                <li v-if="!config.isBeta" @click="handlePlansClick">
                  <span>Pricing</span>
                </li>
                <template
                  v-if="Array.isArray(heartbeats) && heartbeats.length > 0"
                >
                  <hr />
                  <li
                    v-for="(aHeartbeat, hb) in heartbeats"
                    :key="`hb_${hb}`"
                    @click="handleHeartBeatClick(aHeartbeat)"
                  >
                    💛 {{ aHeartbeat.name }}
                  </li>
                  <hr />
                </template>
                <li v-if="hasDashboardAdmin" @click="handleDashboardAdminClick">
                  <span>Admin</span>
                </li>
                <li
                  v-if="hasDashboardBlog"
                  @click="handleDashboardManageBlogClick"
                >
                  <span>Blogger Management</span>
                </li>
                <li
                  v-if="hasDashboardPublishings"
                  @click="handleMyPublishingsClick"
                >
                  <span>App Publishing</span>
                </li>
                <hr />
                <li class="item signout" @click="handleSignOut">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.58334 3.66659C4.34023 3.66659 4.10707 3.76316 3.93516 3.93507C3.76325 4.10698 3.66668 4.34014 3.66668 4.58325V17.4166C3.66668 17.6597 3.76325 17.8929 3.93516 18.0648C4.10707 18.2367 4.34023 18.3333 4.58334 18.3333H8.25001C8.75627 18.3333 9.16668 18.7437 9.16668 19.2499C9.16668 19.7562 8.75627 20.1666 8.25001 20.1666H4.58334C3.854 20.1666 3.15452 19.8769 2.6388 19.3611C2.12307 18.8454 1.83334 18.1459 1.83334 17.4166V4.58325C1.83334 3.85391 2.12307 3.15443 2.6388 2.63871C3.15452 2.12298 3.854 1.83325 4.58334 1.83325H8.25001C8.75627 1.83325 9.16668 2.24366 9.16668 2.74992C9.16668 3.25618 8.75627 3.66659 8.25001 3.66659H4.58334Z"
                      fill="#EF5C4A"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.0185 5.76849C14.3765 5.4105 14.9569 5.4105 15.3148 5.76849L19.8982 10.3518C20.2562 10.7098 20.2562 11.2902 19.8982 11.6482L15.3148 16.2315C14.9569 16.5895 14.3765 16.5895 14.0185 16.2315C13.6605 15.8735 13.6605 15.2931 14.0185 14.9352L17.9536 11L14.0185 7.06485C13.6605 6.70687 13.6605 6.12647 14.0185 5.76849Z"
                      fill="#EF5C4A"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.33334 10.9999C7.33334 10.4937 7.74375 10.0833 8.25001 10.0833H19.25C19.7563 10.0833 20.1667 10.4937 20.1667 10.9999C20.1667 11.5062 19.7563 11.9166 19.25 11.9166H8.25001C7.74375 11.9166 7.33334 11.5062 7.33334 10.9999Z"
                      fill="#EF5C4A"
                    />
                  </svg>
                  <span>Sign Out</span>
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </b-navbar>
    <feed-back-modal
      v-if="profile"
      :modal-id="feedbackModalId"
      :profile="profile"
    />
    <tutorial-and-tour ref="tour" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { quotes } from "./_quotes.json";
import TutorialAndTour from "@/components/common/tutorialAndTour";
import Notifications from "@/components/common/notifications/";
import ToDoneTasks from "@/components/common/toDoneTasks/";
import config from "@/assets/_config.json";

import Iona from "@/components/common/iona";
import CommunicateChat from "@/components/common/communicateChat";
import FeedBackModal from "@/components/common/modalFeedback";
export default {
  name: "HBF_Topbar",
  components: {
    FeedBackModal,
    Iona,
    CommunicateChat,
    Notifications,
    ToDoneTasks,
    TutorialAndTour
  },
  created() {
    this.generateQuote();
    this.getProfile();
    this.getListHeartbeats();
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile",
      heartbeats: "user/heartbeats",
      notifications: "user/listNotifications"
    }),
    myHeartBeatName() {
      return this.profile && this.profile.heartbeat
        ? this.profile.heartbeat.profileName
        : "";
    },
    firstname() {
      return this.profile && this.profile.firstname
        ? this.profile.firstname
        : "";
    },
    lastname() {
      return this.profile && this.profile.lastname ? this.profile.lastname : "";
    },
    imgURLPath() {
      return this.profile && this.profile.imgURL
        ? this.profile.imgURL
        : this.user.PhotoURL;
      //this.user.photoURL;
    },
    hasDashboardAdmin() {
      return (
        this.profile &&
        this.profile._dashboards &&
        this.profile._dashboards.admin &&
        this.profile._dashboards.admin._account &&
        this.profile._dashboards.admin._account.status === "active"
      );
    },
    hasDashboardPublishings() {
      return (
        this.profile &&
        this.profile._dashboards &&
        this.profile._dashboards.guide &&
        this.profile._dashboards.guide &&
        this.profile._dashboards.guide._account.status === "active"
      );
    },
    hasDashboardBlog() {
      return (
        this.profile &&
        this.profile._dashboards &&
        this.profile._dashboards.blogger &&
        this.profile._dashboards.blogger._account &&
        this.profile._dashboards.blogger._account.status === "active"
      );
    }
  },
  watch: {
    profile(val) {
      return val;
    }
  },
  methods: {
    getUser(userRef) {
      let name = "User";
      this.$store.dispatch("user/getUserProfile", userRef).then(res => {
        this.notifyUser = res;
      });
    },
    getProfile() {
      this.$store.dispatch("user/getProfile", "").then(res => {
        this.notifyUser = res;
      });
    },
    getListHeartbeats() {
      this.$store
        .dispatch("user/getListHeartbeats", {})
        .then(res => {})
        .catch(e => {});
    },
    getListNotifications() {
      this.$store
        .dispatch("user/getListNotifications", {})
        .then(res => {})
        .catch(e => {});
    },
    /* GET LISTS ENDED */
    handleProductTourClick() {
      this.$refs.tour.startTutoial();
    },
    generateQuote() {
      if (quotes) {
        const randIdx = Math.floor(Math.random() * this.quotes.length);
        this.quote = this.quotes[randIdx];
      }
    },
    handleNavLogoClick() {
      this.handleMyShelfClick();
    },
    handleMyShelfClick() {
      const route = "/app";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleMyProfileClick() {
      const route = "/app/profile";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleMyHeartBeatNamePageClick() {
      const route = `/heartbeat/${this.myHeartBeatName}`;
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handlePlansClick() {
      const route = "/app/pricing";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleDashboardAdminClick() {
      const route = "/manage/admin";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleHeartBeatClick(heartbeat) {
      const route = `/heartbeat/${heartbeat.slug}`;
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleMyPublishingsClick() {
      const route = "/manage/platform";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleDashboardManageBlogClick() {
      const route = "/manage/blog";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    showHelp() {
      0;
      this.$emit("showHelp");
    },
    getInitials(fname, lname) {
      let initials = "";
      if (fname) initials += fname[0];
      if (lname) initials += lname[0];
      return initials;
    },
    handleSignOut() {
      this.$store
        .dispatch("user/signOutAction")
        .then(async result => {
          await this.$router.push("/signin");
        })
        .catch(err => {
          alert("Oops. " + err.message);
        });
    }
  },
  data() {
    return {
      feedbackModalId: "feedback-modal-id",
      config,
      helpModal: false,
      // notifications: [],
      profilePanel: false,
      quote: null,
      quotes,
      notifyUser: null
    };
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: 60px;
  box-shadow: 0px -2px 8px 0px #ccc;
  display: flex;
  align-items: center;
  position: fixed;
  width: calc(100% - 60px);
  background: white;
  z-index: 7;

  .nav-item-content {
    width: 100%;
    padding: 0 20px;
  }

  .qoute {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .qoute-coma {
      margin-top: -2px;
      margin-right: 10px;
    }
    h4 {
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #474d52;
      margin: 0;
    }
  }
  .hamburger {
    margin: 0 10px;
    cursor: pointer;
  }
  .actions {
    button,
    div {
      margin: 0 10px;
    }
    button {
      padding: 8px 15px;
      font-size: 16px;
      line-height: 22px;
      height: 44px;
      .text {
        margin-left: 3px;
        vertical-align: middle !important;
      }
    }
    .overlay {
      position: fixed;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background-color: rgba(189, 189, 189, 0);
      z-index: 8;
    }

    .profile {
      position: relative;
      & > div {
        cursor: pointer;
      }
      .avatar {
        height: 40px;
        width: 40px;
        object-fit: cover;
        border-radius: 50%;
      }
      span {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        font-family: "Nunito", sans-serif;
        color: #474d52;
        margin-left: 10px;
      }
      .profile-panel {
        z-index: 10;
        position: absolute;
        top: 40px;
        right: -25px;
        background-color: #fff;
        padding: 10px 5px;
        width: 205px;
        box-shadow: 0px 0px 8px 0 #eee;
        border-radius: 10px;

        ul {
          padding: 0;
          list-style-type: none;
          li {
            display: block;
            padding: 8px;
            a {
              font-weight: 700;
              text-decoration: none;
              font-family: "Nunito", sans-serif;

              span {
                font-size: 14px;
                line-height: 19px;
                color: #474d52;
              }
              &:hover {
                background: red;
                box-shadow: none !important;
              }
            }
            &:hover {
              background: #cad0d6;
            }
            &.signout {
              color: red;
            }
          }
          .divider {
            border-top: 1px solid #b3c2cb;
            width: 205px;
            margin-left: -6px;
            margin-top: 10px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

@media (max-width: 1500px) {
}
@media (max-width: 1440px) {
  .qoute {
    h4 {
      display: block;
    }
  }
}
@media (max-width: 1160px) {
  .top-bar {
    .qoute {
      h4 {
        display: none;
      }
      .qoute-coma {
        display: none;
      }
    }

    .hamburger {
      /*margin: 0 10px;*/
      float: left !important;
      /*ma*/
    }
  }
}

@media (max-width: 768px) {
  .actions {
    button {
      width: unset !important;
      .text {
        display: none;
      }
    }

    .username {
      display: none;
    }
  }
}

@media (max-width: 558px) {
  .top-bar .actions button,
  .top-bar .actions div {
    margin: 0 4px;
  }
  .top-bar .actions button {
    padding: 4px 10px;
  }
  .top-bar .actions .notification {
    /*position: unset;*/
    .notifications-panel {
      position: fixed;
      width: 100%;
      right: 0;
      left: 0;
      top: 60px;
      bottom: 0;
    }
  }
  .top-bar .actions .profile .profile-panel {
    right: 0;
  }
}

@media (min-width: 1440px) {
  .top-bar {
    width: calc(100% - 234px);
  }
  .top-bar.full {
    width: calc(100% - 60px);
  }
}
/*button:hover,*/
/*a:hover{*/
/*    box-shadow: 0px 2px 6px 0px #cbcbcb;*/
/*    cursor: pointer;*/
/*}*/
</style>
